<template>
<div :class="selectorClass">
    <div class="cfd-label"
        ref="label"
        @mousedown="labelMousedownHandler"
        @click="labelClickHandler">{{ label }}</div>
    <input class="cfd-input" v-model="localValue" type="text"
        :tabindex="tabindex"
        ref="input"
        :disabled="disabled"
        @focus="inputFocusHandler"
        @blur="inputBlurHandler"
        @mousedown="inputMousedownHandler">
</div>
</template>

<script>
export default {
    name: 'InputSelector',

    props: {
        label: {
            type: String,
            required: true
        },
        value: String,
        tabindex: {
            type: [String, Number],
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            isFocused: false,
            isFloated: false,
            isTouchMoved: false,
            isTouchHandled: false
        }
    },

    computed: {
        localValue: {
            get () {
                return this.value;
            },
            set (value) {
                this.$emit('input', value);
            }
        },

        selectorClass () {
            return {
                'cfd-selector': true,
                'is-focused': this.isFocused,
                'is-floated': this.isFloated,
                'is-filled': this.isFilled,
                'is-disabled': this.disabled
            };
        },

        isFilled () {
            return this.localValue !== '';
        }
    },

    methods: {
        labelMousedownHandler () {
            if (this.isFocused) {
                this.isFloated = true;
            }
        },

        labelClickHandler () {
            this.$refs.input.focus();
        },

        inputFocusHandler () {
            if (this.disabled) {
                return;
            }
            this.isFocused = true;
            this.isFloated = false;
        },

        inputBlurHandler () {
            this.isFocused = false;
        },

        inputMousedownHandler () {
            // helps IE to receive focus
            this.$refs.input.focus();
        },

        globalTouchstartHandler () {
            this.isTouchMoved = false;
            this.isTouchHandled = false;
        },

        globalTouchmoveHandler () {
            this.isTouchMoved = true;
        },

        globalTouchendHandler (ev) {
            this.isTouchHandled = true;
            if (this.isTouchMoved) {
                return;
            }
            const closestInput = ev.target.closest && ev.target.closest('.cfd-input');
            const closestLabel = ev.target.closest && ev.target.closest('.cfd-label');
            if (closestInput === this.$refs.input || closestLabel === this.$refs.label) {
                return;
            }
            this.$refs.input.blur();
        },

        globalMousedownHandler (ev) {
            if (this.isTouchHandled) {
                return;
            }
            const closestInput = ev.target.closest && ev.target.closest('.cfd-input');
            const closestLabel = ev.target.closest && ev.target.closest('.cfd-label');
            if (closestInput === this.$refs.input || closestLabel === this.$refs.label) {
                return;
            }
            this.$refs.input.blur();
        }
    },

    mounted () {
        document.addEventListener('touchstart', this.globalTouchstartHandler);
        document.addEventListener('touchmove', this.globalTouchmoveHandler);
        document.addEventListener('touchend', this.globalTouchendHandler);
        document.addEventListener('mousedown', this.globalMousedownHandler);
    },

    destroyed () {
        document.removeEventListener('touchstart', this.globalTouchstartHandler);
        document.removeEventListener('touchmove', this.globalTouchmoveHandler);
        document.removeEventListener('touchend', this.globalTouchendHandler);
        document.removeEventListener('mousedown', this.globalMousedownHandler);
    }
}
</script>

<style scoped>
.cfd-selector {
    position: relative;
    z-index: 1;
    margin-top: 28px;
}

.cfd-label {
    position: absolute;
    z-index: 1;
    top: 6px;
    font-size: 16px;
    line-height: 20px;
    color: rgba(0, 0, 0, .54);
    transition: all .125s ease-in;
}

.cfd-selector.is-filled .cfd-label,
.cfd-selector.is-focused .cfd-label,
.cfd-selector.is-floated .cfd-label {
    top: -14px;
    font-size: 12px;
    line-height: 14px;
    color: #f60;
    cursor: default;
    transition-timing-function: ease-out;
}

.cfd-selector.is-disabled .cfd-label {
    color: rgba(0, 0, 0, .38);
}

.cfd-input {
    position: relative;
    z-index: 1;
    display: block;
    width: 100%;
    border: 0;
    border-bottom: 1px solid rgba(0, 0, 0, .42);
    border-radius: 0;
    padding: 6px 0;
    font-size: 16px;
    line-height: 20px;
    outline: 0;
    background-color: transparent;
    box-shadow: inset 0 -2px 0 -1px transparent;
    transition: border .125s ease-in, box-shadow .125s ease-in;
}

.cfd-input:hover {
    border-bottom-color: rgba(0, 0, 0, .87);
    box-shadow: inset 0 -2px 0 -1px rgba(0, 0, 0, .87);
    transition-timing-function: ease-out;
}

.cfd-selector.is-focused .cfd-input {
    border-bottom-color: #f60;
    box-shadow: inset 0 -2px 0 -1px #f60;
    transition-timing-function: ease-out;
}

.cfd-selector.is-disabled .cfd-input {
    border-bottom: 1px dotted rgba(0, 0, 0, .42);
    cursor: default;
    box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/selectors/InputSelector.vue